/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { useTranslation } from 'react-i18next';

import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import MeetingRoomOutlinedIcon from '@mui/icons-material/MeetingRoomOutlined';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import FilterVintageIcon from '@mui/icons-material/FilterVintageOutlined';
import TextSnippetIcon from '@mui/icons-material/TextSnippetOutlined';
import GroupsIcon from '@mui/icons-material/GroupsOutlined';

import RadioColumn from './RadioColumn';

export default function Step1({
  usage,
  usageOtherText,
  interest,
  interestOtherText,
  onUpdate,
}) {
  const { t } = useTranslation();

  const useCases = [
    { title: t('Intervjuer'), icon: GroupOutlinedIcon, value: 'interviews' },
    { title: t('Möten'), icon: MeetingRoomOutlinedIcon, value: 'meetings' },
    { title: t('Media'), icon: GraphicEqIcon, value: 'media' },
    { title: t('Annat'), icon: MoreHorizIcon, value: 'other' },
  ];

  const interests = [
    { title: t('AI-summeringar'), value: 'summaries', icon: FilterVintageIcon },
    {
      title: t('Transkribering och sökbarhet i ljud'),
      value: 'transcripts',
      icon: TextSnippetIcon,
    },
    { title: t('Mötesinspelningar'), value: 'meetings', icon: GroupsIcon },
    { title: t('Annat'), value: 'other', icon: MoreHorizIcon },
  ];

  return (
    <div
      css={css`
        display: flex;
        gap: 1rem;

        @media (max-width: 700px) {
          flex-direction: column;
        }
      `}
    >
      <RadioColumn
        options={useCases}
        value={usage}
        onValueChange={(value) => onUpdate({ usage: value })}
        text={usageOtherText}
        onTextChange={(value) => onUpdate({ usageOtherText: value })}
        title={t('För vilken typ av innehåll kommer du använda Klang.ai?')}
        label={t('Ange hur du kommer använda Klang.ai')}
      />
      <RadioColumn
        options={interests}
        value={interest}
        onValueChange={(value) => onUpdate({ interest: value })}
        text={interestOtherText}
        onTextChange={(value) => onUpdate({ interestOtherText: value })}
        title={t('Vad är du mest intresserad av?')}
        label={t('Ange vad du är intresserad av')}
      />
    </div>
  );
}
